import React, {useState, useEffect} from 'react';
import styles from "../../styles/competitor-players-stats-module.module.scss";
import classNames from "classnames";
import {CompetitorPlayersStatsModuleShotChart} from "../shot_chart/competitor-players-stats-module.shot-chart";
import {CompetitorPlayersStatsModulePlayerStatsShotMapSelector} from "./competitor-players-stats-module.player-stats.shot-map.selector";
import {observer} from 'mobx-react';
import {COMPETITOR_PLAYER_STATS} from "../../competitor-players-stats-module.consts";

export const CompetitorPlayersStatsModulePlayerStatsShotMap = observer(({controller, width}) => {
  const {state, terms} = controller;
  const {courtRatio, shouldRenderShotMap, isGoalViewExpanded, isFootball, isShallowShotMap} = state;
  const [courtWidth, setCourtWidth] = useState(null);
  const [courtHeight, setCourtHeight] = useState(null);
  const {WEB_SHOT_MAP_SHOW_LESS, WEB_SHOT_MAP_SHOW_MORE} = terms;
  const label: String = isGoalViewExpanded ? WEB_SHOT_MAP_SHOW_LESS : WEB_SHOT_MAP_SHOW_MORE;

  useEffect(() => {
    setCourtWidth(parseInt(width))
    setCourtHeight(parseInt(width / courtRatio))
  }, [width])

  const shotChartProps = {
    controller,
    width: courtWidth,
    height: courtHeight
  }

  const buttonProps = {
    className: classNames(styles.shot_navigation),
    onClick: () => controller.action(COMPETITOR_PLAYER_STATS.ACTION_TYPES.onGoalViewExpanded, {isVisible: !isGoalViewExpanded, isButtonClick: true})
  }

  return (
    shouldRenderShotMap ? <div className={classNames(styles.shot_map_content)}>
      <CompetitorPlayersStatsModuleShotChart {...shotChartProps}/>
      <CompetitorPlayersStatsModulePlayerStatsShotMapSelector controller={controller}/>
      {
        isFootball && !isShallowShotMap? <div {...buttonProps}>{label}</div> : null
      }
    </div> : null
  )
});
